import risize from '@/layout/Home/mixin/RisizeTable'
import notification from './notification'
export default {
  mixins: [risize, notification],
  data() {
    return {
      //主页面的top表单
      topForm: {
        ref: null,
        fieldList: null,
        data: {
          orderNo: null,
          deliveryNo: null,
          rejectNo: null,
          customerName: null,
          rejectReason: null
        },
        rules: {},
        labelWidth: '110px',
      },
      //下拉选项列表
      listTypeInfo: {},
      //主页面表格
      tableInfo: {
        fieldList: null,
        handle: {
          fixed: 'right',
          label: '操作',
          width: '220',
          btList: [

          ]
        }
      },
      //详情弹窗
      diaDetailInfo: {
        ref: null,
        data: {},
        fieldList: [],
      },
      //提交审批弹窗
      dialogSubmit: {
        title: "",
        visible: false,
        loading: false,
        submitLoading: false,
        detailData: {},
        form: {
          approveResultNo: '10', // 10-通过 99-驳回
          remark: '',
        },
        rules: {},
        btList: [],
      },
    }
  },
  mounted() {
    this.initTopFormColumns();
  },
  methods: {
    //主页面初始化数据
    initTopFormColumns() {
      //初始化top表单
      this.topForm.fieldList = []
      this.topForm.handle = {
        btList: [],
        formBtList: [],
      };
      //初始化列表
      this.tableInfo.fieldList = []
    },
    /**
     * 详情弹窗配置
     */
    diaDetailInfoFieldList() {},
    reset() {
      this.topForm.data = {}
    },
    handleClick(event, data) {
      if (event) {
        this[event](data);
      }
    },
    handleEvent(event, data) {
      if (event) {
        this[event](data);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/reject/rejectApprovalShow/mixins/index.js